import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
declare var $;

@Component({
  selector: 'app-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements OnInit {

  @Input() public title:string;
  @Input() public description:string;
  @Input() public callback:string;

  @Output() public goToCallback:EventEmitter<string> = new EventEmitter;

  constructor() { }

  ngOnInit() {
  }

  emit(){
    
    if(this.callback)
      this.goToCallback.emit(this.callback);
  }

  close(){

    this.emit();
    $('#danger-modal').modal('hide');
  }

  open(data){
    
    this.fill(data);
    $('#danger-modal').modal('show');
  }

  fill(data){
    this.title = data.title;
    this.description = data.description;
    this.callback = data.callback;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/modals/error-modal/error-modal.component.ts